import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Clock, ExternalLink } from 'lucide-react';
export function PortalContact() {
  return <section id="contact" className="py-16 bg-white" data-id="element-518">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-519">
        <div className="bg-brand-navy text-white rounded-2xl p-8 md:p-10 text-center shadow-lg" data-id="element-520">
          <h2 className="text-2xl font-bold mb-6" data-id="element-521">
            Need additional assistance?
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8" data-id="element-522">
            <div className="flex items-center gap-3" data-id="element-523">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center" data-id="element-524">
                <Phone className="text-brand-red" size={24} data-id="element-525" />
              </div>
              <div className="text-left" data-id="element-526">
                <p className="text-sm text-blue-200 font-medium" data-id="element-527">
                  Call Us Toll-Free
                </p>
                <a href="tel:888-765-3854" className="text-xl font-bold hover:text-brand-red transition-colors" data-id="element-528">
                  888-765-3854
                </a>
              </div>
            </div>

            <div className="hidden md:block w-px h-12 bg-white/20" data-id="element-529"></div>

            <div className="flex items-center gap-3" data-id="element-530">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center" data-id="element-531">
                <Clock className="text-brand-red" size={24} data-id="element-532" />
              </div>
              <div className="text-left" data-id="element-533">
                <p className="text-sm text-blue-200 font-medium" data-id="element-534">
                  Business Hours
                </p>
                <p className="font-semibold" data-id="element-535">Mon-Fri, 8am - 5pm ET</p>
              </div>
            </div>
          </div>

          <p className="text-blue-100 text-sm max-w-lg mx-auto mb-6" data-id="element-536">
            For all other questions, including disputes and validation requests,
            please contact our office directly during business hours.
          </p>

          <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-white hover:text-brand-red transition-colors" data-id="element-537">
            Visit compassrecoverygroup.com for more information
            <ExternalLink size={16} data-id="element-538" />
          </Link>
        </div>
      </div>
    </section>;
}